import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { site } from "@/data/site";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-background text-white py-24 px-6 md:px-12">
      <div className="max-w-3xl mx-auto">
        <Link to="/" data-testid="impressum-back" className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-10 text-sm">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight mb-10">Impressum</h1>

        <div className="space-y-8 text-white/70 leading-relaxed text-sm">
          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">Angaben gemäß § 5 DDG</h2>
            <p>
              Tesla-Verleih-Frankfurt · Mobilitätsberatung<br />
              {site.street}<br />
              {site.city}
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">Kontakt</h2>
            <p>
              Telefon: {site.phoneDisplay}<br />
              E-Mail: {site.email}
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">Verantwortlich für den Inhalt</h2>
            <p>Tesla-Verleih-Frankfurt · Mobilitätsberatung, {site.street}, {site.city}</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte
              fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
              rechtswidrige Tätigkeit hinweisen.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
              der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-white mb-2">Markenhinweis</h2>
            <p>
              Tesla ist eine eingetragene Marke der Tesla, Inc. Diese Website steht in keiner
              geschäftlichen Verbindung zur Tesla, Inc.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
